import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import FullLogo from '../assets/logos/full-logo.png'
import CirclesBg from '../assets/svgs/not-found-circles.svg'
import {
  FooterContent,
  PageWrapper,
  BgCircles,
  ContentArea,
  SearchCircle,
  PageTitle,
  ScheduledInfoContainer,
  ScheduledInfoBox,
  ScheduledInfoBoxIcon,
  ScheduledInfoBoxText,
  ScheduledDetailsBox,
  ScheduledDetailsLabel,
  ScheduledDetailsText,
} from '../components/styled'
import theme from '../constants/theme'
import SuccessIcon from '../assets/svgs/SuccessIcon'
import CalendarSquare from '../assets/svgs/calendarSquare'
import Clock from '../assets/svgs/clock'

function ScheduledNotification() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const [scheduledDate, setScheduledDate] = useState(null)
  const [scheduledTime, setScheduledTime] = useState(null)
  const [additionalDetails, setAdditionalDetails] = useState(null)

  useEffect(() => {
    // Get data from navigation state
    if (location.state) {
      setScheduledDate(location.state.scheduledDate)
      setScheduledTime(location.state.scheduledTime)
      setAdditionalDetails(location.state.additionalDetails)
    } else {
      // If no state, redirect to home or show error
      // navigate('/')
    }
  }, [location, navigate])

  const InfoBox = ({ icon, children }) => (
    <ScheduledInfoBox>
      <ScheduledInfoBoxIcon>{icon}</ScheduledInfoBoxIcon>
      <ScheduledInfoBoxText>{children}</ScheduledInfoBoxText>
    </ScheduledInfoBox>
  )

  InfoBox.propTypes = {
    icon: PropTypes.node,
    children: PropTypes.node,
  }

  return (
    <PageWrapper>
      <div className="p-3 ps-4">
        <img height="auto" width="130" src={FullLogo} alt="Valentino" />
      </div>

      <BgCircles>
        <img src={CirclesBg} alt="" aria-hidden="true" className="w-100" />
      </BgCircles>

      <ContentArea>
        <SearchCircle
          style={{ marginBottom: '1.5rem', borderColor: `${theme.success}30` }}
        >
          <SuccessIcon color={theme.success} />
        </SearchCircle>

        <PageTitle style={{ width: '50%' }}>
          {t('calendar.interviewBookedSuccess')}
        </PageTitle>

        {(scheduledDate || scheduledTime || additionalDetails) && (
          <ScheduledInfoContainer>
            {scheduledDate && (
              <InfoBox
                icon={
                  <CalendarSquare
                    width="20px"
                    height="20px"
                    color={theme.success}
                  />
                }
              >
                {scheduledDate}
              </InfoBox>
            )}

            {scheduledTime && (
              <InfoBox
                icon={
                  <Clock width="20px" height="20px" color={theme.success} />
                }
              >
                {scheduledTime}
              </InfoBox>
            )}

            {additionalDetails && (
              <ScheduledDetailsBox>
                <ScheduledDetailsLabel>
                  {t('calendar.additionalDetails')}
                </ScheduledDetailsLabel>
                <ScheduledDetailsText>{additionalDetails}</ScheduledDetailsText>
              </ScheduledDetailsBox>
            )}
          </ScheduledInfoContainer>
        )}
      </ContentArea>

      <FooterContent className="fixed-bottom text-center text-gray-100 py-2 border-t border-gray-200">
        {t('footer.TalentinoAI')} © {new Date().getFullYear()}{' '}
        {t('footer.allRightsReserved')}
      </FooterContent>
    </PageWrapper>
  )
}

export default ScheduledNotification
